var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTableView',{attrs:{"head":_vm.tableHead}},_vm._l((_vm.items),function(item,key){return _c('EmployeesGroupListItem',{key:key,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }